import { ethers } from 'ethers';

const NFT_CONTRACT_ADDRESS = "0x68269b368c1AA01Ab9f843e519d09d82B5A557E8"; // Replace with your contract address
const NFT_ABI = [
    "function ownerOf(uint256 tokenId) external view returns (address)"
];

export const checkNFT = async (tokenId) => {
    try {
        // Initialize the provider for the Polygon network
        const provider = new ethers.JsonRpcProvider("https://polygon-rpc.com/");

        // Ensure tokenId is in string format (if not already)
        const tokenIdString = tokenId.toString();

        // Instantiate the NFT contract with the provider
        const nftContract = new ethers.Contract(NFT_CONTRACT_ADDRESS, NFT_ABI, provider);

        // Call the contract method to check NFT ownership
        const owner = await nftContract.ownerOf(tokenIdString);
        // // Check if the owner address returned is valid
        return ethers.isAddress(owner);
    } catch (error) {
        console.error("Error checking NFT ownership:", error);
        return false;
    }
};
